
<div *transloco="let t" class="flex flex-col overflow-hidden lg:h-available p-4 lg:p-12">
  <div class=" flex justify-between items-center p-2">
    <div class="font-thin text-3xl">
      {{t('profile.myArtworks')}}
    </div>
    <div class="flex justify-end">
      <button wunButton primary (click)="createNewArtwork()" transloco="artworks.new">
      </button>
    </div>
  </div>
  <div wunRightContainer class="!flex-1 !overflow-auto !h-full !gap-8">
    @for (artwork of myArtworks.value()?.data; track artwork.id) {
      <div class="flex flex-col justify-between overflow-hidden h-112" #attach>
        @let status = artwork.status;
        @if (artwork.mainAttachment) {
          @let media = artwork.mainAttachment;
          <a [class]="{
          'hover:border-wundart-blue-400': status === 'CREATED'
          }" class="transition-colors duration-300 border-transparent border-4 flex h-full items-center relative overflow-hidden justify-center bg-slate-50" >
            @if (status === 'CREATED') {
              <div class="absolute w-full z-10 bg-wundart-blue-500 bg-opacity-80 text-white uppercase h-full left-0 top-0 flex justify-center items-center">
                <div class="text-xl font-bold">
                  {{t('ARTWORK_ENUM.MY_ARTWORK.CREATED')}}
                </div>
              </div>
            }
            <div class="absolute group w-full z-10 hover:bg-wundart-black hover:bg-opacity-50 text-white uppercase h-full left-0 top-0 flex justify-center items-center transition-colors duration-300">
                <div class="text-xl font-bold hidden group-hover:flex gap-3">
                  <button class="bg-white text-black p-2 rounded hover:bg-gray-100 transition-colors" (click)="$event.preventDefault(); openEdit(artwork)">
                    <wun-pencil-rule-icon wunIcon />
                  </button>
                  <button class="bg-wundart-red-500 text-white p-2 rounded hover:opacity-80 transition-opacity" (click)="$event.preventDefault(); selectToBeDeleted(artwork)">
                    <wun-trash-icon wunIcon />
                  </button>
                </div>
              </div>
            <wun-media-render [attachTo]="attach"  [media]="media" [medias]="artwork.attachments || []" />
          </a>
        }
        <div class="flex flex-col gap-3">
          <div class="font-extralight text-xl">
            {{artwork.name}}
          </div>
          <div class="font-bold text-2xl" [class.text-transparent]="!artwork.price">
            {{artwork.price | currency : 'EUR' : '' : '1.2-2' }} €
          </div>
        </div>
      </div>
    }
  </div>
</div>

<cms-modal [(show)]="show">
  <wun-new-artwork-form [(show)]="show" (closeClicked)="show.set(false)" class="block p-3" />
</cms-modal>


<cms-modal [(show)]="askDeleteArtwork">
  <div *transloco="let t" class="w-96 p-4 m-auto max-w-full rounded-sm bg-white flex flex-col gap-3">
    <div class="flex justify-between">
      <div>
        Attenzione!
      </div>
      <div>
        <wun-times-icon class="cursor-pointer" (click)="askDeleteArtwork.set(false)" />
      </div>
    </div>
    <div>
      Se cancelli l`opera non potrai piú recuperarla
    </div>
    <div class="flex justify-end gap-3">
      <button wunButton danger (click)="deleteArtwork()">{{t('common.confirm')}}</button>
      <button wunButton primary (click)="askDeleteArtwork.set(false)">{{t('common.cancel')}}</button>
    </div>
  </div>
</cms-modal>

<cms-modal [(show)]="showEdit">
  <wun-new-artwork-form
    [(show)]="showEdit"
    [(artworkToEdit)]="artworkToEdit"
    (closeClicked)="showEdit.set(false); myArtworks.reload()"
    class="block p-3" />
</cms-modal>
